const countryCodes = [
    { label: 'US +1', value: '+1' },
    { label: 'GB +44', value: '+44' },
    { label: 'AU +61', value: '+61' },
    { label: 'IN +91', value: '+91' },
    { label: 'DE +49', value: '+49' },
    { label: 'FR +33', value: '+33' },
    { label: 'ES +34', value: '+34' },
    { label: 'IT +39', value: '+39' },
    { label: 'BR +55', value: '+55' },
    { label: 'ZA +27', value: '+27' },
    { label: 'JP +81', value: '+81' },
    { label: 'CN +86', value: '+86' },
    { label: 'MX +52', value: '+52' },
    { label: 'RU +7', value: '+7' },
    { label: 'NL +31', value: '+31' },
    { label: 'BE +32', value: '+32' },
    { label: 'TR +90', value: '+90' },
    { label: 'CH +41', value: '+41' },
    { label: 'SE +46', value: '+46' },
    { label: 'NO +47', value: '+47' },
    { label: 'DK +45', value: '+45' },
    { label: 'FI +358', value: '+358' },
    { label: 'PL +48', value: '+48' },
    { label: 'IE +353', value: '+353' },
    { label: 'CZ +420', value: '+420' },
    { label: 'AT +43', value: '+43' },
    { label: 'HU +36', value: '+36' },
    { label: 'GR +30', value: '+30' },
    { label: 'PT +351', value: '+351' },
    { label: 'RO +40', value: '+40' },
    { label: 'NZ +64', value: '+64' },
    { label: 'SG +65', value: '+65' },
    { label: 'TH +66', value: '+66' },
    { label: 'ID +62', value: '+62' },
    { label: 'PH +63', value: '+63' },
    { label: 'MY +60', value: '+60' },
    { label: 'KR +82', value: '+82' },
    { label: 'VN +84', value: '+84' },
    { label: 'BD +880', value: '+880' },
    { label: 'TW +886', value: '+886' },
    { label: 'AE +971', value: '+971' },
    { label: 'SA +966', value: '+966' },
    { label: 'QA +974', value: '+974' },
    { label: 'IL +972', value: '+972' },
    { label: 'EG +20', value: '+20' },
    { label: 'NG +234', value: '+234' },
    { label: 'KE +254', value: '+254' },
    // ... Add more as needed
];

export default countryCodes;
